<template>
  <div class="wrapper">
    <div class="topo-header centro">
      <botao-voltar nomeRota="Formularios" />
      <h1>{{ formularioForm.id ? "Editar" : "Novo" }} Formulário</h1>
    </div>
    <div class="tab-dados-basicos">
      <div class="form centro">
        <MsgErroFormularios
          v-if="erro && msgErros"
          :mensagens="msgErros"
          :erro="erro"
          @fechar-erro="fecharErro"
        />
        <p>Os campos com asterisco (*) são de preenchimento obrigatório.</p>
        <form @submit.prevent="enviarForm">
          <!-- Título do Formulário -->
          <div class="caixa-form item">
            <div class="item">
              <label><b>{{ possuiAsterisco("Título:") }}</b></label>
              <textarea
                rows="1"
                placeholder="Digite o título do formulário"
                v-model="formularioForm.texto"
              ></textarea>
            </div>
              <br>
            <!-- Selecionar Unidade Administrativa -->
              <div class="item">
                <label for="selectUnidade"><b>* Unidades:</b></label>
                  <v-select
                    id="selectUnidades"
                    multiple
                    placeholder="Selecione uma ou mais unidades administrativas"
                    class="vselect"
                    v-model="formularioForm.unidade_ids"                    
                    :options="unidadesFormatadas" :reduce="(unidade) => unidade.id"
                    label="nomeCompleto" >
                  </v-select>
              </div>
            <br>
            <!------------------------DATAS(prazo)------------------------>
            <div class="flexbox-2">
              <!-- Data de inicio da cessão -->
              <div class="item">
                <label><b>* Período Avaliado - Início:</b></label>
                <date-picker
                  v-model="formularioForm.data_periodo_inicio"
                  format="DD/MM/YYYY"
                  type="date"
                  placeholder="Selecione a data inicial do período avaliado"
                >
                </date-picker>
              </div>
              <!-- Data de término da cessão -->
              <div class="item">
                <label><b>* Período Avaliado - Final:</b></label>
                <date-picker
                  v-model="formularioForm.data_periodo_final"
                  format="DD/MM/YYYY"
                  type="date"
                  placeholder="Selecione a data final do período avaliado"
                >
                </date-picker>
              </div>
            </div>
            <br>
            <div class="flexbox-2">
              <!-- Data de inicio da cessão -->
              <div class="item">
                <label><b>* Data de início da Avaliação:</b></label>
                <date-picker
                  v-model="formularioForm.data_inicio"
                  format="DD/MM/YYYY"
                  type="date"
                  placeholder="Selecione a data de início da avaliação"
                >
                </date-picker>
              </div>
              <!-- Data de término da cessão -->
              <div
                class="item"
                v-if="this.formularioForm.termino_indeterminado !== true"
              >
                <label><b>* Data de término da Avaliação:</b></label>
                <date-picker
                  v-model="formularioForm.data_final"
                  format="DD/MM/YYYY"
                  type="date"
                  placeholder="Selecione a data de final da avaliação"
                >
                </date-picker>
              </div>
            </div>
            <br>
            <!-- Adicionar Perguntas -->
            <MultiplasPerguntas v-model="formularioForm.perguntas_attributes" />
            <!-- Selecionar o tipo de Pergunta - Múltipla escolha / Escolha Única / Discursiva -->

            <!---->
            <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                <p id="conteudo-botao">
                  {{ formularioForm.id ? "Atualizar" : "Criar" }}
                </p>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import FormularioApi from "../../services/FormularioApi";
import BotaoVoltar from "../../components/BotaoVoltar.vue";
import MsgErroFormularios from "../MsgErroFormularios";
import MultiplasPerguntas from "../../components/formularios/MultiplasPerguntas.vue";
import UnidadesApi from "../../services/UnidadesApi";


import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import DatePicker from "vue2-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "FormularioForm",
  props: {
    formulario: {
      type: Object,
      required: false,
    },
  },
  components: {
    BotaoVoltar,
    MsgErroFormularios,
    vSelect,
    DatePicker,
    MultiplasPerguntas,
  },
  data() {
    let initialState;
    const formProp = this.formulario;

    if (formProp) {
      initialState = {
        id: formProp.id,
        texto: formProp.texto || formProp.titulo,
        unidade_ids: formProp.unidade_id || formProp.id_unidade,
        data_inicio: formProp.data_inicio ? new Date(formProp.data_inicio) : null,
        data_final: formProp.data_final ? new Date(formProp.data_final) : null,
        data_periodo_inicio: formProp.data_periodo_inicio ? new Date(formProp.data_periodo_inicio) : null,
        data_periodo_final: formProp.data_periodo_final ? new Date(formProp.data_periodo_final) : null,

        perguntas_attributes: (formProp.perguntas_formulario || []).map(pf => ({
          id: pf.id,
          pergunta_id: pf.pergunta_id,
          tipo_pergunta: pf.tipo_pergunta,
          ordem: pf.ordem,
          _destroy: false,
          alternativas_attributes: (pf.alternativas || []).map(alt => ({
            id: alt.id,
            resposta: alt.resposta,
            _destroy: false
          }))
        })),
      };
    } else {
      initialState = {
        id: null,
        texto: "",
        unidade_ids: [],
        data_inicio: null,
        data_final: null,
        data_periodo_inicio: null,
        data_periodo_final: null,
        perguntas_attributes: [],
      };
    }

    return {
      erro: false,
      msgErros: {
        texto: '',
        default: '',
      },
      unidade: [],
      formularioForm: initialState,
    };
  },
  computed: {
    unidadesFormatadas() {
      // Garante que não dê erro se a lista estiver carregando
      if (!this.unidade || this.unidade.length === 0) {
        return [];
      }
      
      // Transforma cada item da lista
      return this.unidade.map(u => ({
        ...u, // Mantém todas as propriedades originais (id, nome, sigla)
        // Cria uma nova propriedade para usar como label no v-select
        nomeCompleto: `${u.nome} (${u.sigla || ''})`
      }));
    }
  },
  created() {
    this.formularioApi = new FormularioApi();
    this.unidadeApi = new UnidadesApi();
    this.carregarUnidades();
  },
  methods: {
    fecharErro() {
      this.erro = false;
    },
    async carregarUnidades() {
      try {
        this.unidade = await this.unidadeApi.getUnidades();
      } catch (err) {
        this.erro = true;
        this.msgErros.default = "Não foi possível carregar a lista de unidades.";
      }
    },
    async enviarForm() {
      // Validação básica do título
      if (!this.formularioForm.texto || this.formularioForm.texto.trim() === '') {
        this.msgErros.texto = "O título do formulário não pode ficar em branco.";
        this.erro = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      if (!this.formularioForm.unidade_ids || this.formularioForm.unidade_ids.length === 0) {
        this.msgErros.default = "Selecione ao menos uma unidade para este formulário.";
        this.erro = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // Prepara perguntas com alternativas
      const perguntasFormatadas = (this.formularioForm.perguntas_attributes || []).map(pf => ({
        id: pf.id || undefined,
        pergunta_id: pf.pergunta_id,
        tipo_pergunta: pf.tipo_pergunta,
        ordem: pf.ordem,
        _destroy: pf._destroy || false,
        alternativas_attributes: (pf.alternativas_attributes || []).map(a => ({
          id: a.id || undefined,
          resposta_id: a.resposta ? a.resposta.id : null, // Extrai o ID do objeto resposta
          _destroy: a._destroy || false
        }))
      }));

      const dadosFormatados = {
        id: this.formularioForm.id || undefined,
        titulo: this.formularioForm.texto,
        unidade_ids: this.formularioForm.unidade_ids,
        data_inicio: this.formularioForm.data_inicio,
        data_final: this.formularioForm.data_final,
        data_periodo_inicio: this.formularioForm.data_periodo_inicio,
        data_periodo_final: this.formularioForm.data_periodo_final,
        perguntas_formulario_attributes: perguntasFormatadas
      };

      const payload = {
        formulario: dadosFormatados
      };

      try {
        this.erro = false;
        const dataFormulario = await this.formularioApi.setFormulario(payload);

        this.$router.push({
          name: "FormularioShow",
          params: { id: dataFormulario.id }
        });

      } catch (err) {
        console.error(err);
        this.erro = true;
        const { response } = err;
        if (response && response.data) {
          this.msgErros = response.data;
        } else {
          this.msgErros.default = "Houve um erro ao salvar o registro. Por favor, tente novamente.";
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },

    possuiAsterisco(texto) {
      var texto_final = "* " + texto;
      return texto_final;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .vselect .vs__search::placeholder {
  color: #aaa; /* Um tom de cinza mais claro */
}
.itemTop {
  display: inline,

}
.wrapper {
  padding: 1.5rem;
}
input[type="checkbox"] {
  transform: scale(1.5); /* aumenta 50% */
  margin: 0 5px;         /* ajusta espaço do lado */
}
.ativo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 2rem;
}
.caixa-form {
  background-color: #f0f0f0;
  padding: 1.5rem;
  border-radius: 8px;
}
.item {
  margin-bottom: 1.5rem;
}
label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}
textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: inherit;
  font-size: 1rem;
}
.checkbox-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bt-salvar button {
  padding: 0.75rem 1.5rem;
  background-color: #005516;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}
.bt-salvar button:hover {
  background-color: #003d0f;
}
.flexbox-2 {
    display: flex;
    gap: 1.5rem;
}
.radioContainer {
    display: flex;
    gap: 1.5rem;
    margin-top: 0.5rem;
}
.radioOption {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
.radioOption label {
    font-weight: normal;
    margin-bottom: 0;
    cursor: pointer;
}
</style>
